/* ------------------------------------------------------------------------------
@name: Product
--------------------------------------------------------------------------------- */

import { API_URL } from "variables";
import { SweetAlert } from "utilities";

const Product = (() => {
  let activeInput = null;

  const escapeHtml = (value) => String(value || "").replace(/[&<>"']/g, (char) => ({
    "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;",
  }[char]));

  const handlerGetProduct = (search = "", callback = null) => {
    $.ajax({
      url: API_URL.productGet,
      method: "POST",
      dataType: "JSON",
      data: { search },
      success: (response) => {
        const products = response.data || [];
        const content = products.map((product) => `
          <li class="form-dropdown-item">
            <div class="product-option">
              <span class="form-dropdown-select product-option-select" data-value="${escapeHtml(product.name)}" data-id="${product.id}" data-hs-code="${escapeHtml(product.hs_code)}">
                <span class="product-option-name">${escapeHtml(product.name)}</span><small class="product-option-hs">${escapeHtml(product.hs_code || "-")}</small>
              </span>
              <div class="product-option-actions">
                <button type="button" class="product-option-action js-edit-master-product" data-id="${product.id}" title="Edit product"><i class="ph ph-pencil-simple"></i></button>
                <button type="button" class="product-option-action is-delete js-delete-master-product" data-id="${product.id}" title="Remove product"><i class="ph ph-trash"></i></button>
              </div>
            </div>
          </li>`).join("");
        $(".js-list-product").each(function () {
          $(this).html(`${content}<li class="form-dropdown-notif"><button type="button" class="btn btn-block btn-custom waves-effect waves-light form-dropdown-btn js-add-input-product">+ New Product</button></li>`);
        });
        if (typeof callback === "function") callback();
      },
      error: () => {
        $(".js-list-product").html('<li class="form-dropdown-notif"><button type="button" class="btn btn-block btn-custom form-dropdown-btn js-add-input-product">+ New Product</button></li>');
        if (typeof callback === "function") callback();
      },
    });
  };

  const openProductModal = ({ id = "", name = "", hsCode = "", input = null } = {}) => {
    activeInput = input;
    $("#product_master_id").val(id);
    $("#product_master_name").val(name);
    $("#product_master_hs_code").val(hsCode);
    $("#productMasterModal .modal-title").text(id ? "Edit Product" : "Add Product");
    $("#productMasterModal").modal("show");
  };

  const bindProductActions = () => {
    $("body").on("input", ".js-input-product", function () {
      const $input = $(this);
      $input.attr("data-id", "").closest(".js-row-product").find('[data-field="hs_code"]').val("");

      if (!$input.val().trim()) {
        handlerGetProduct("");
      }
    });

    $("body").on("click", ".js-add-input-product", function (event) {
      event.preventDefault();
      event.stopPropagation();
      const $row = $(this).closest(".js-row-product");
      const $input = $row.find(".js-input-product");
      openProductModal({ name: ($input.val() || "").trim(), input: $input });
    });

    $("body").on("click", ".js-open-new-product", function (event) {
      event.preventDefault();
      const $row = $(this).closest(".js-row-product");
      const $input = $row.find(".js-input-product");
      openProductModal({ name: ($input.val() || "").trim(), input: $input });
    });

    $("body").on("click", ".js-edit-master-product", function (event) {
      event.preventDefault();
      event.stopPropagation();
      const $item = $(this).closest(".form-dropdown-item");
      const $select = $item.find(".form-dropdown-select");
      const $row = $(this).closest(".js-row-product");
      openProductModal({ id: $(this).data("id"), name: $select.data("value"), hsCode: $select.attr("data-hs-code"), input: $row.find(".js-input-product") });
    });

    $("body").on("click", ".js-delete-master-product", function (event) {
      event.preventDefault();
      event.stopPropagation();
      const id = $(this).data("id");
      const $item = $(this).closest(".form-dropdown-item");
      swal({ title: "Remove product?", text: "The product will be hidden from the product list.", type: "warning", showCancelButton: true, confirmButtonText: "Remove", cancelButtonText: "Cancel" }).then((result) => {
        if (!result || result.dismiss) return;
        $.post(API_URL.productDelete, { product_id: id }, (response) => {
          if (response.code === 200) $item.remove();
          SweetAlert.config(response.message, response.code === 200 ? "success" : "error");
        }, "json");
      });
    });

    $("#productMasterForm").on("submit", function (event) {
      event.preventDefault();
      const id = $("#product_master_id").val();
      const name = $("#product_master_name").val().trim();
      const hsCode = $("#product_master_hs_code").val().trim();
      if (!name) {
        $("#product_master_name").focus();
        return;
      }
      const data = { product_name: name, hs_code: hsCode };
      const url = id ? API_URL.productEdit : API_URL.productAdd;
      if (id) data.product_id = id;
      $.ajax({ url, method: "POST", dataType: "JSON", data })
        .done((response) => {
          if (response.code !== 200 && response.code !== 409) {
            SweetAlert.config(response.message || "Could not save product", "error");
            return;
          }
          const saved = response.data || { id, name, hs_code: hsCode };
          if (activeInput) {
            activeInput.val(saved.name || name).attr("data-id", saved.id || id);
            activeInput.closest(".js-row-product").find('[data-field="hs_code"]').val(saved.hs_code || hsCode);
          }
          $("#productMasterModal").modal("hide");
          handlerGetProduct("", () => {
            if (activeInput) activeInput.closest(".form-dropdown").addClass("form-dropdown-show");
          });
          SweetAlert.config(response.message, "success");
        })
        .fail(() => SweetAlert.config("Could not save product", "error"));
    });
  };

  const init = () => {
    if ($(".js-list-product").length) handlerGetProduct();
    bindProductActions();
  };

  return { init };
})();

export default Product;
